import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { exploreMenu } from '../../../explore/data/explore-menu';
@Component({
  selector: 'app-explore-menu',
  templateUrl: './explore-menu.component.html',
  styleUrls: ['./explore-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExploreMenuComponent implements OnInit {

  baseAnatomyCategories = exploreMenu.baseAnatomyCategories;
  categories = exploreMenu.categories;

  constructor() {
  }

  ngOnInit() {
  }

}
